module.exports = __webpack_public_path__ + "img/sld_mfm_inv_10_t1_b1_dark.786d99c7.svg";